import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { config } from "./utils/tenantConfig";

function setFavicon(href: string) {
	const link =
		document.querySelector("link[rel='icon']") ??
		Object.assign(document.createElement("link"), { rel: "icon" });

	link.setAttribute("href", href);
	link.setAttribute(
		"type",
		href.endsWith(".png") ? "image/png" : "image/x-icon"
	);
	document.head.appendChild(link);
}

function loadGtm() {
	if (!config.gtm) {
		return;
	}

	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" });

	const script = document.createElement("script");
	script.async = true;
	script.src = `${config.gtm.scriptBaseUrl}${config.gtm.id}`;
	script.dataset.gtmContainerId = config.gtm.id;
	document.head.appendChild(script);
}

setFavicon(config.favicon);
loadGtm();

const root = ReactDOM.createRoot(
	document.getElementById("root") as HTMLElement
);
root.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
